import {
  PartnerGroupRules,
  useGroupRules,
  usePartnerGroupRules,
  UserGroupRules,
} from 'src/graphql';
import { useSelectedConversation } from 'src/pages/Conversations/use-selected-conversation';
import { useSelectedConversation as useSelectedConversationStore } from 'src/store/selected-conversation';

type SelectedConversation = ReturnType<typeof useSelectedConversation>['selectedConversation'];

export interface SidekickAccess {
  canViewPolicies: boolean;
  canManagePolicies: boolean;
  canUseAiChat: boolean;
  conversationPartnerId?: number | null;
  selectedConversation?: SelectedConversation;
}

/** AI Chat is reachable through the user's own rule or the conversation partner's. */
export const useSidekickAccess = (): SidekickAccess => {
  const { checkValidity } = useGroupRules();
  const { conversationId } = useSelectedConversationStore();
  const { selectedConversation } = useSelectedConversation({
    conversationId: conversationId ?? '',
  });

  const conversationPartnerId = selectedConversation?.partnerId;
  const { partnerGroupRules } = usePartnerGroupRules(conversationPartnerId);

  const canViewPolicies = checkValidity([UserGroupRules.AccessToSupportPoliciesInAssistant]);
  const canManagePolicies = checkValidity([
    UserGroupRules.AccessToManageSupportPoliciesInAssistant,
  ]);
  const canUseAiChat =
    checkValidity([UserGroupRules.AccessToProvisionSidekick]) ||
    Boolean(partnerGroupRules?.[PartnerGroupRules.AccessToProvisionSidekick]);

  return {
    canViewPolicies,
    canManagePolicies,
    canUseAiChat,
    conversationPartnerId,
    selectedConversation,
  };
};
